<template>
    <div style="border: 1px solid #f2f2f2;" v-loading="loading">
        <img @click="downloadImg" :src="imgUrl" style="width: 100%">

        <div class="print-part">
            <quotationFormat :record="recordObj" :itemList="itemList" :clientObj="clientObj" :companyObj="companyObj" @print-complete="printCallback" v-if="null != recordObj" />
        </div>
    </div>
</template>

<script setup>
    import quotationFormat from "@/components/shopopee/print/quotationFormat"
    import {inject, onBeforeMount, ref} from "vue";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import myUtil from "@/util/util";


    const props = defineProps(["quotationRef", "acccompanycode", "printFlag"])

    const loading = ref(true)
    const i18n = inject("i18n")

    const recordObj = ref(null)
    const itemList = ref(null)
    const clientObj = ref(null)
    const companyObj = ref(null)

    const imgUrl = ref("")

    function getQuotationInfo() {
        const request = eshopopeeApi.getQuotationRecord
        const params = request.getParams()

        params.ref = props.quotationRef
        params.companycode = props.acccompanycode

        request.send(params, (res) => {
            if (res.code == 200){
                if (null != res.record && res.record.length > 0){
                    itemList.value = res.list
                    clientObj.value = res.client[0]
                    companyObj.value = res.company[0]
                    recordObj.value = res.record[0]
                }
            }
        })

    }

    function downloadImg() {
        if (myUtil.isEmpty(imgUrl.value)){
            return
        }

        // 创建a标签
        const link = document.createElement('a');
        // 设置a标签为不可见
        link.style.display = 'none';
        // 将a标签添加到body
        document.body.appendChild(link);
        // 设置a标签的href
        link.href = imgUrl.value;
        // 设置a标签的download
        link.download = `${props.quotationRef}.jpg`;
        // 模拟点击事件进行下载
        link.click();
        // 下载完成后移除a标签
        document.body.removeChild(link);

        myUtil.alertSuccess(i18n.tkey("lang_now_downloading"))
    }


    function printCallback(url){
        imgUrl.value = url
        loading.value = false
    }

    function getImgUrl(){
        return imgUrl.value
    }

    onBeforeMount(() => {
        getQuotationInfo()
    })

    defineExpose({
        downloadImg,
        getImgUrl
    })
</script>

<style scoped>
    .print-part {
        width: 2000px;
        height: 2000px;
        position: fixed;
        top: 200vh;
        left: 0;
    }

    .operation-box {
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: right;
        font-size: 16px;
    }
</style>